import i18next from 'i18next';
import { ReactComponent as PendingIcon } from 'assets/icons/pending.svg';
import { ReactComponent as ShippedIcon } from 'assets/icons/shipped.svg';
import { ReactComponent as ProcessingIcon } from 'assets/icons/processing.svg';
import { ReactComponent as HoldIcon } from 'assets/icons/hold.svg';
import permissions from '../../config/permissions';
import { CUSTOM_TAGS_OPTIONS } from '../Shared/CustomTags';
import { INFO_PANE_PAGES } from '../../redux_store';
import FILTER_TYPES from '../Shared/Table/widgets/Filters/constants';

export const CLAIMS_STATUSES = {
  invited: 'invited',
  inProgress: 'inProgress',
  pendingReview: 'pendingReview',
  completed: 'completed',
  processing: 'processing',
  scheduled: 'scheduled',
};

export const ENCOUNTER_CLAIMS_STATUSES = {
  draft: 'draft',
  notCreated: 'notCreated',
  completed: 'completed',
};

export const PAYMENT_METHOD_CLAIMS_SELECTOR_OPTIONS = [
  {
    label: 'Check',
    value: 'check',
  },
  {
    label: 'ACH',
    value: 'ach',
  },
  {
    label: 'CASH',
    value: 'cash',
  },
  {
    label: 'Credit Card',
    value: 'creditCard',
  },
];

export const PR_TYPE_CLAIMS_SELECTOR_OPTIONS = [
  {
    label: 'Copay',
    value: 'copay',
  },
  {
    label: 'Coinsurance',
    value: 'coinsurance',
  },
  {
    label: 'Deductible',
    value: 'deductible',
  },
];

export const BILLING_CLAIMS_STATUSES = {
  billed: 'billed',
  pending: 'pending',
  icdIssue: 'icdIssue',
  insuranceIssue: 'insuranceIssue',
  appointmentCancelled: 'appointmentCancelled',
  readyToBill: 'readyToBill',
  appointmentTypeIssue: 'appointmentTypeIssue',
  hold: 'hold',
};

export const BILLING_CLAIMS_SELECTOR_OPTIONS = [
  {
    label: 'Billed',
    value: 'billed',
  },
  {
    label: 'Pending',
    value: 'pending',
  },
  {
    label: 'ICD Issue',
    value: 'icdIssue',
  },
  {
    label: 'Insurance Issue',
    value: 'insuranceIssue',
  },
  {
    label: 'Appt. Cancelled',
    value: 'appointmentCancelled',
  },
  {
    label: 'Ready for Billing',
    value: 'readyToBill',
  },
  {
    label: 'Appt. Type Issue',
    value: 'appointmentTypeIssue',
  },
  {
    label: 'Hold',
    value: 'hold',
  },
];

export const CLAIM_ENTITY_TYPE_SELECTOR_OPTIONS = [
  {
    label: 'Program',
    value: 'program',
  },
  {
    label: 'Assessment',
    value: 'assessment',
  },
  {
    label: 'Resource',
    value: 'resource',
  },
  {
    label: 'IntellyChart',
    value: 'intellyChart',
  },
  {
    label: 'BHI Webhook',
    value: 'bhi-webhook',
  },
];

export const CPT_STATUS_SELECTOR_OPTIONS = [
  {
    label: 'Billed',
    value: 'billed',
  },
  {
    label: 'Patient Responsibility',
    value: 'patientResponsibility',
  },
  {
    label: 'In Process',
    value: 'inProcess',
  },
  {
    label: 'Paid',
    value: 'paid',
  },
  {
    label: 'Denied',
    value: 'denied',
  },
  {
    label: 'Resubmitted',
    value: 'resubmitted',
  },
  {
    label: 'Not Billable',
    value: 'notBillable',
  },
];

export const CLAIM_STATUS_SELECTOR_STATUSES = {
  billed: 'billed',
  patientResponsibility: 'patientResponsibility',
  inProcess: 'inProcess',
  paid: 'paid',
  partiallyPaid: 'partiallyPaid',
  denied: 'denied',
  resubmitted: 'resubmitted',
  notBillable: 'notBillable',
  pending: 'pending',
};

export const CLAIM_STATUS_SELECTOR_OPTIONS = [
  {
    label: 'Billed',
    value: 'billed',
  },
  {
    label: 'Patient Responsibility',
    value: 'patientResponsibility',
  },
  {
    label: 'In Process',
    value: 'inProcess',
  },
  {
    label: 'Paid',
    value: 'paid',
  },
  {
    label: 'Partially Paid',
    value: 'partiallyPaid',
  },
  {
    label: 'Denied',
    value: 'denied',
  },
  {
    label: 'Resubmitted',
    value: 'resubmitted',
  },
  {
    label: 'Not Billable',
    value: 'notBillable',
  },
  {
    label: 'Pending',
    value: 'pending',
  },
];

export const ENCOUNTER_CLAIMS_STATUSES_OPTIONS = [
  {
    label: i18next.t('tables:draft'),
    value: ENCOUNTER_CLAIMS_STATUSES.draft,
    icon: HoldIcon,
    enabledForNonSponsors: false,
  },
  {
    label: i18next.t('tables:notCreated'),
    value: ENCOUNTER_CLAIMS_STATUSES.notCreated,
    icon: ProcessingIcon,
    enabledForNonSponsors: false,
  },
  {
    label: i18next.t('tables:completed'),
    value: ENCOUNTER_CLAIMS_STATUSES.completed,
    icon: ShippedIcon,
    enabledForNonSponsors: true,
  },
];

export const BILLING_CLAIMS_STATUSES_OPTIONS = [
  {
    label: i18next.t('tables:billed'),
    value: BILLING_CLAIMS_STATUSES.billed,
    icon: HoldIcon,
    enabledForNonSponsors: false,
  },
  {
    label: i18next.t('tables:pending'),
    value: BILLING_CLAIMS_STATUSES.pending,
    icon: PendingIcon,
    enabledForNonSponsors: true,
    addDivider: true,
  },
  {
    label: i18next.t('tables:hold'),
    value: BILLING_CLAIMS_STATUSES.hold,
    icon: PendingIcon,
    enabledForNonSponsors: true,
  },
  {
    label: i18next.t('tables:icdIssue'),
    value: BILLING_CLAIMS_STATUSES.icdIssue,
    icon: ProcessingIcon,
    enabledForNonSponsors: false,
  },
  {
    label: i18next.t('tables:insuranceIssue'),
    value: BILLING_CLAIMS_STATUSES.insuranceIssue,
    icon: ProcessingIcon,
    enabledForNonSponsors: false,
  },
  {
    label: i18next.t('tables:appointmentTypeIssue'),
    value: BILLING_CLAIMS_STATUSES.appointmentTypeIssue,
    icon: ProcessingIcon,
    enabledForNonSponsors: true,
  },
  {
    label: i18next.t('tables:appointmentCancelled'),
    value: BILLING_CLAIMS_STATUSES.appointmentCancelled,
    icon: ShippedIcon,
    enabledForNonSponsors: true,
  },
  {
    label: i18next.t('tables:readyToBill'),
    value: BILLING_CLAIMS_STATUSES.readyToBill,
    icon: ShippedIcon,
    enabledForNonSponsors: true,
  },
];

export const GET_CLAIMS_COLUMNS = (isPatientPage) => [
  {
    size: 200,
    header: i18next.t('tables:customTags'),
    accessorKey: 'accountCustomTags',
    filter: {
      filterType: FILTER_TYPES.SELECT,
      options: CUSTOM_TAGS_OPTIONS,
    },
    cell: {
      withBubbles: true,
    },
    permission: permissions.ACCOUNTS_GET,
  },
  {
    size: 220,
    header: i18next.t('tables:account'),
    accessorKey: 'accountBusinessName',
    filter: {
      filterType: FILTER_TYPES.SELECT_WITH_DYNAMIC_HINT,
    },
    permission: permissions.ACCOUNTS_GET,
    enableHiding: false,
    isDefaultCell: true,
  },
  {
    size: 180,
    header: i18next.t('tables:customId'),
    accessorKey: 'accountCustomIdentifier',
    filter: {},
    permission: permissions.ACCOUNTS_GET,
    enableHiding: false,
    isDefaultCell: true,
  },
  {
    size: 200,
    header: i18next.t('tables:mrnNumber'),
    accessorKey: 'patientMrnNumber',
    filter: {},
    cell: {
      infoPanePage: INFO_PANE_PAGES.patient_page,
    },
  },
  {
    size: 240,
    header: i18next.t('tables:patientFirstName'),
    accessorKey: 'patientFirstName',
    filter: {},
    hidden: isPatientPage,
    cell: {
      infoPanePage: INFO_PANE_PAGES.patient_page,
    },
  },
  {
    size: 240,
    header: i18next.t('tables:patientLastName'),
    accessorKey: 'patientLastName',
    filter: {},
    hidden: isPatientPage,
    cell: {
      infoPanePage: INFO_PANE_PAGES.patient_page,
    },
  },
  {
    size: 200,
    header: i18next.t('tables:patientDOB'),
    accessorKey: 'patientDateOfBirth',
    filter: {
      filterType: FILTER_TYPES.DATE,
    },
    hidden: isPatientPage,
    isDefaultCell: true,
  },
  {
    size: 280,
    header: i18next.t('tables:assessmentResource'),
    accessorKey: 'entityName',
    filter: {
      filterType: FILTER_TYPES.SELECT_WITH_DYNAMIC_HINT,
    },
    isDefaultCell: true,
  },
  {
    size: 200,
    header: i18next.t('tables:orderDate'),
    accessorKey: 'entityOrderTimestamp',
    filter: {
      shouldRange: true,
      filterType: FILTER_TYPES.DATE,
    },
    isDefaultCell: true,
  },
  {
    size: 270,
    header: i18next.t('tables:claimGeneratedTimestamp'),
    accessorKey: 'claimGeneratedTimestamp',
    filter: {
      shouldRange: true,
      filterType: FILTER_TYPES.DATE,
    },
    isDefaultCell: true,
  },
  {
    size: 200,
    header: i18next.t('tables:createdBy'),
    accessorKey: 'createdBy',
    filter: {
      filterType: FILTER_TYPES.SELECT_WITH_DYNAMIC_HINT,
    },
    isDefaultCell: true,
  },
  {
    size: 200,
    header: i18next.t('tables:lastModifiedTimestamp'),
    accessorKey: 'lastModifiedTimestamp',
    filter: {
      shouldRange: true,
      filterType: FILTER_TYPES.DATE,
    },
    isDefaultCell: true,
  },
  {
    size: 200,
    header: i18next.t('tables:modifiedBy'),
    accessorKey: 'modifiedBy',
    filter: {
      filterType: FILTER_TYPES.SELECT_WITH_DYNAMIC_HINT,
    },
    isDefaultCell: true,
  },
  {
    size: 250,
    header: i18next.t('tables:appointmentDate'),
    accessorKey: 'appointmentTimestamp',
    filter: {
      shouldRange: true,
      hasNoMaxDate: true,
      filterType: FILTER_TYPES.DATE,
    },
    isDefaultCell: true,
  },
  {
    size: 220,
    header: i18next.t('tables:entityCompletedTimestamp'),
    accessorKey: 'entityCompletedTimestamp',
    filter: {
      shouldRange: true,
      filterType: FILTER_TYPES.DATE,
    },
    isDefaultCell: true,
  },
  {
    size: 220,
    header: i18next.t('tables:encounterStatus'),
    accessorKey: 'encounterStatus',
    filter: {
      filterType: FILTER_TYPES.SELECT,
      options: ENCOUNTER_CLAIMS_STATUSES_OPTIONS,
    },
    cell: {
      withBubble: true,
    },
  },
  {
    size: 220,
    header: i18next.t('tables:billingStatus'),
    accessorKey: 'billingStatus',
    filter: {
      filterType: FILTER_TYPES.SELECT,
      options: BILLING_CLAIMS_STATUSES_OPTIONS,
    },
    cell: {
      withBubble: true,
    },
  },
  {
    size: 200,
    header: i18next.t('tables:claimStatus'),
    accessorKey: 'claimStatus',
    filter: {
      filterType: FILTER_TYPES.SELECT,
      options: CLAIM_STATUS_SELECTOR_OPTIONS,
    },
    cell: {
      withBubble: true,
    },
  },
  {
    size: 200,
    header: i18next.t('tables:entityType'),
    accessorKey: 'entityType',
    filter: {
      filterType: FILTER_TYPES.SELECT,
      options: CLAIM_ENTITY_TYPE_SELECTOR_OPTIONS,
    },
  },
  {
    size: 180,
    header: i18next.t('tables:dos'),
    accessorKey: 'dos',
    filter: {
      shouldRange: true,
      filterType: FILTER_TYPES.DATE,
    },
    isDefaultCell: true,
  },
  {
    size: 200,
    header: i18next.t('tables:cptCount'),
    accessorKey: 'cptCount',
    filter: {},
    isDefaultCell: true,
  },
  {
    size: 250,
    header: i18next.t('tables:cptPaid'),
    accessorKey: 'cptPaid',
    filter: {},
    isDefaultCell: true,
  },
];

